import { Paper, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useRecoilState } from 'recoil';
import { mapStyleAtom, MapStyle } from '../../../models/atoms/ui_atoms';
import { useTranslation } from '../../../contexts/TranslationContext';
import { useIsMobile } from '../../../hooks/useIsMobile';

export const MapStyleToggle = () => {
  const [style, setStyle] = useRecoilState(mapStyleAtom);
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    nextView: MapStyle | null,
  ) => {
    if (nextView !== null) {
      setStyle(nextView);
    }
  };

  return (
    <Paper
      sx={{
        position: 'absolute',
        top: isMobile ? 0 : '1rem',
        left: isMobile ? 0 : '1rem',
        p: 0.5,
      }}
    >
      <ToggleButtonGroup
        exclusive
        size="small"
        value={style}
        onChange={handleChange}
      >
        <ToggleButton value="streets">{t('Street View')}</ToggleButton>
        <ToggleButton value="satellite">{t('Satellite View')}</ToggleButton>
      </ToggleButtonGroup>
    </Paper>
  );
};
